export const RETURN_TO_USER = 'user';

export function studentProfilePath(userId: string, from?: string): string {
  if (!from) return `/usuarios/${userId}`;
  const params = new URLSearchParams();
  params.set('from', from);
  return `/usuarios/${userId}?${params.toString()}`;
}

function isSafeAppPath(value: string): boolean {
  return value.startsWith('/') && !value.startsWith('//') && !value.includes('://') && !value.includes('\\');
}

/** Destino del botón Volver del perfil. Null si hay que usar el historial. */
export function profileOriginBack(
  searchParams: URLSearchParams,
  canListUsers: boolean,
): { to: string; label: string } | null {
  const from = searchParams.get('from');
  if (from && isSafeAppPath(from)) {
    const path = (from.split('?')[0] ?? from).replace(/\/$/, '');
    if (canListUsers || path !== '/usuarios') return { to: from, label: 'Volver' };
  }
  if (canListUsers) return { to: '/usuarios', label: 'Volver a gestión de usuarios' };
  return null;
}

export function userReturnQuery(userId: string): string {
  const params = new URLSearchParams();
  params.set('return_to', RETURN_TO_USER);
  params.set('user_id', userId);
  return `?${params.toString()}`;
}

export function userOriginBack(
  searchParams: URLSearchParams,
  fallbackTo: string,
  fallbackLabel: string,
  pathUserId?: string,
): { to: string; label: string } {
  if (searchParams.get('return_to') !== RETURN_TO_USER) {
    return { to: fallbackTo, label: fallbackLabel };
  }
  const userId = searchParams.get('user_id') ?? pathUserId;
  if (!userId) return { to: fallbackTo, label: fallbackLabel };
  return { to: `/usuarios/${userId}`, label: 'Volver al usuario' };
}
